<template lang="pug">
  #ContactsIndex
    b-card.rounded-0(
      bg-variant="light",
      no-body
    )
      b-card-body.py-2.px-3(
        class="searchArea"
      )
        .position-relative
          h5.text-center 顧客通訊錄
          i.fas.fa-angle-up.fa-lg.searchArea__iconArrow(
            v-b-toggle.collapse-searchBody
          )
        b-collapse#collapse-searchBody(
          visible
        )
          b-form-group.mb-2(
            label="顧客姓名："
          )
            b-input-group
              b-form-input(
                v-model="searchInput.customer_name",
                placeholder="請輸入顧客姓名"
              )
          .row.no-gutters
            .col-6.pr-1
              b-button(
                variant="primary",
                block,
                @click="resetSearchHandler()"
              ) 重置
            .col-6.pl-1
              b-button(
                variant="primary",
                block,
                @click="searchHandler()"
              ) 搜尋
    .p-3
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(user,index) in memberList",
        :key="user.member_id",
        @click="showUserInfoHandler(user.member_id)"
      )
        .row
          .col-2.d-flex.align-items-center.justify-content-center(
            v-show="selectMode"
          )
            b-form-checkbox(
              :id="`checkbox-group-${index}`",
              v-model="selectUsers",
              :name="`user-${index}`",
              :value="user",
              v-show="selectMode"
            )
          div(
            :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
          )
            label.w-100.mb-0(
              :for="`checkbox-group-${index}`"
            )
              .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
                .col-6.pr-1
                  ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                    :profileUrl="user.picture_url",
                    :style="{ 'width': '80px', 'height': '80px' }"
                  )
                .col-6.pl-1
                  p.mb-0.font-weight-bold 暱稱名 {{ user.line_display_name }}
                  p.mb-0 備註名 {{ user.note_name ? user.note_name : '-' }}
              .reserveAtRow.mb-2.d-flex.align-items-center
                i.far.fa-calendar-check.mr-2
                small 最後預約時間：{{ user.latest_reservation_start_at ? user.latest_reservation_start_at : '無' }}
              .labelRow.d-flex.align-items-center.flex-wrap.mb-3
                i.fas.fa-tag
                  small.pl-2 顧客標籤：
                    small(
                      v-if="user.tags && user.tags.length > 0"
                    )
                      b-badge.m-1.rounded-50.px-2.py-1(
                        variant="primary",
                        v-for="tag in user.tags"
                        :key="tag.tag_id"
                      ) {{ tag.name }}
                    small(
                      v-else
                    ) 無
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
    //- 群發訊息按鈕
    .button-fixedArea
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.iconBtn.iconPushBtn(
        variant="primary",
        @click="selectUserHandler(true)"
      )
        i.fas.fa-volume-up.iconPush
      small.d-block.w-100.text-center 群發訊息
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.button-close.iconBtn.iconPushBtn(
        variant="gray",
        v-if="selectMode",
        @click="selectUserHandler(false)"
      )
        i.fas.fa-times
      b-badge.rounded-50.d-flex.align-items-center.justify-content-center.button.button-people.iconBtn.iconPushBtn.p-1(
        pill,
        variant="danger",
        v-if="selectMode"
      )
        span {{ selectUsers.length }}
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SM_GROUP_PUSH_INDEX } from '@/router/sm/group-push';
import { SM_MY_CUSTOMER_INDEX } from '@/router/sm/my-customer';

export default {
  name: 'ContactsIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      searchInput: {
        customer_name: null
      },
      selectMode: false,
      selectUsers: [],
      infiniteId: +new Date()
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sm_contacts/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('sm_contacts/getMemberListHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        line_display_name: vm.searchInput.customer_name
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    selectUserHandler(mode) {
      const vm = this;
      // 如果是點推播按鈕且目前在選擇使用者模式
      if (mode && vm.selectMode && vm.selectUsers && vm.selectUsers.length > 0) {
        vm.$store.commit('sm_group_push/setMemberList', vm.selectUsers);
        vm.$router.push({
          name: SM_GROUP_PUSH_INDEX
        });
      } else {
        vm.selectUser = [];
        vm.selectMode = mode;
      }
    },
    showUserInfoHandler(userId) {
      const vm = this;
      if (vm.selectMode) return;
      vm.$router.push({
        name: SM_MY_CUSTOMER_INDEX,
        params: {
          userId
        }
      }).catch(() => {});
    },
    searchHandler() {
      const vm = this;
      if (!vm.searchInput.customer_name) return;
      vm.$store.commit('sm_contacts/resetHandler');
      vm.infiniteId += 1;
    },
    resetSearchHandler() {
      const vm = this;
      vm.searchInput.customer_name = null;
      vm.$store.commit('sm_contacts/resetHandler');
      vm.infiniteId += 1;
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sm_contacts.memberList,
      pagination: (state) => state.sm_contacts.pagination
    })
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;
    vm.$store.commit('sm_contacts/resetHandler');
    next();
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}
</style>
